{
  "eyebrow": "Conferma il tuo piano",
  "title": "Rivedi e configura.",
  "sub": "Puoi cambiare il ciclo di fatturazione o il piano all’interno della tua linea di prodotto in qualsiasi momento dalla dashboard amministrativa. Il passaggio tra Time e Project si organizza con il nostro team.",
  "yourPlan": "Il tuo piano",
  "changePlan": "Cambia piano",
  "billing": "Ciclo di fatturazione",
  "billingMonthLabel": "Pagamento mensile",
  "billingMonthDesc": "Flessibile. Annulla quando vuoi.",
  "billingYearLabel": "Pagamento annuale",
  "billingYearDesc": "15% di sconto. Fatturato una volta l'anno.",
  "addons": "Componenti aggiuntivi",
  "addon": {
    "ssec": "Sicurezza sociale (check-in/out@work)",
    "ssecDesc": "Solo Belgio — dichiarazione Dimona automatica.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS live per i veicoli aziendali. +4,80 €/veicolo/mese.",
    "vehicles": "Veicoli"
  },
  "users": {
    "title": "Di quanti utenti hai bisogno?",
    "help": "Ogni persona che utilizza Done-it conta come un utente, inclusi amministratori e dipendenti.",
    "active": "utenti"
  },
  "estimate": "Costo mensile stimato",
  "estimateNote": "IVA esclusa. Paghi per il numero di utenti impostato qui e potrai modificarlo in seguito.",
  "estimateUnavailable": "Catalogo prezzi non disponibile. Riprova per caricare i prezzi più recenti."
}
